/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_C3WAL0u2C",
    "aws_user_pools_web_client_id": "1u9is29retjkb2dbfmklsae64q",
    "oauth": {
        "domain": "us-east-1c3wal0u2c.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "skroop-blog",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "amplifyConfig": {
        "Auth": {
            "Cognito": {
                "userPoolId": "us-east-1_C3WAL0u2C",
                "userPoolClientId": "1u9is29retjkb2dbfmklsae64q",
                "signUpVerificationMethod": "code"
            }
        }
    }
};


export default awsmobile;
